import { SURVEY_LAYER_CLASSIFICATION_ICONS } from '../../../constants/SurveyLayers';
import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import Styles from '../FieldStatisticsContainer.module.less';
import PropTypes from 'prop-types';

const SoilOptixColumnCell = ({ stats, onHoverChildren }) => {
  let primary = '-';
  let secondary = '-';
  let icon;
  if (stats.raw) {
    const raw = stats.raw;
    if (raw.mean) {
      primary = `${raw.mean.toFixed(1)}`;
    }

    if (raw.std) {
      secondary = `± ${raw.std.toFixed(1)}`;
    }
  } else if (stats.mode) {
    primary = stats.mode.replaceAll('_', ' ');
    secondary = null;
  }

  const demand = stats.demand;
  if (demand && demand.mode) {
    icon = SURVEY_LAYER_CLASSIFICATION_ICONS[demand.mode];
  }

  return (
    <Box
      className={Styles.soilOptixCell}
      sx={{
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          flex: '0 0 32px',
        }}
      />
      <Box
        sx={{
          flex: '1 1 0',
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        {primary && <Typography className={Styles.title}>{primary}</Typography>}
        {secondary && <Typography className={Styles.subtitle}>{secondary}</Typography>}
      </Box>
      <Box
        sx={{
          flex: '0 0 32px',
          position: 'relative',
          display: 'flex',
          justifyContent: 'center',
        }}
      >
        {icon && (
          <span className={Styles.classificationIcon}>
            {React.cloneElement(icon, { style: { fontSize: '16px' } })}
          </span>
        )}
        {onHoverChildren && (
          <Box
            className={Styles.shortcut}
            sx={{
              position: 'absolute',
              top: 0,
              right: 0,
            }}
          >
            {onHoverChildren}
          </Box>
        )}
      </Box>
    </Box>
  );
};

SoilOptixColumnCell.propTypes = {
  stats: PropTypes.object,
  onHoverChildren: PropTypes.object,
};

export default memo(SoilOptixColumnCell);
